import { useSelector } from 'react-redux';
import { selectCustomizedEntityStatementOfFactsConfig } from '../../selectors';

export const useCustomizedEntityStatementOfFacts = () => {
  return useSelector(selectCustomizedEntityStatementOfFactsConfig);
};
